export default __webpack_public_path__ + "static/media/S-021.d0c8568f.png";